<main>
  <div class="container-fluid">
    <h1 class="mt-4">Trademark Management</h1>
    <ol class="breadcrumb mb-4">
      <li class="breadcrumb-item active">Trademark Management</li>
    </ol>

    <div class="row">
      <div class="col">
        <button class="btn btn-primary" (click)="openTrademarkModal('')">Add Trademark</button>
      </div>
    </div>

    <div class="row">
      <div class="col mt-3">
        <form>
          <input name="find" type="text" class="form-control" placeholder="Search trademarks..." [(ngModel)]="query.queryString"
                 (ngModelChange)="queryTrademarks()">
        </form>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <table class="table table-bordered table-hover mt-3">
          <thead>
            <tr>
              <th>Text</th>
              <th>Note</th>
              <th>Team</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let t of queryResult.items">
              <td>{{t.text}}</td>
              <td>{{t.note || '-'}}</td>
              <td>{{t.merchantGroup?.name || '-'}}</td>
              <td>
                <button class="btn btn-primary" (click)="openTrademarkModal(t.id)">
                  <i class="fas fa-pen-square"></i>
                </button>
                <button class="btn btn-danger ml-2" (click)="deleteTrademark(t)">
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
            <tr *ngIf="queryResult.items.length === 0">
              <td colspan="4" class="text-center">No trademarks found</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="float-right">
      <app-pagination [(pageNumber)]="query.pageNumber" [pageSize]="query.pageSize" [totalItems]="queryResult.total"
                      (onPageChanged)="queryTrademarks($event)">
      </app-pagination>
    </div>
  </div>

  <ng-template #trademarkModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">
        <span *ngIf="trademarkDetail.id">Edit</span>
        <span *ngIf="!trademarkDetail.id">Create New</span> Trademark
      </h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form name="trademarkDetail">
        <div class="form-group row">
          <label class="col-2 col-form-label">Text *</label>
          <div class="col-10">
            <input type="text" class="form-control" [(ngModel)]="trademarkDetail.text" name="text" required>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-2 col-form-label">Note</label>
          <div class="col-10">
            <textarea class="form-control" rows="3" [(ngModel)]="trademarkDetail.note" name="note"></textarea>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Cancel click')">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="saveTrademark()">Save</button>
    </div>
  </ng-template>
</main>

